import { TileImage } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ProductDetailsTile/TileImage";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { BrandRating } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/LoggedOutSuppliersPage/__internal__/Components/LoggedOutSuppliersPageBrandReviewTile/__internal__/BrandRating";
import { useStrictLocalization } from "@faire/web--source/common/localization/localize";
import { useFormatMoney } from "@faire/web--source/common/money";
import { Column } from "@faire/web--source/slate/Layout/Column";
import { Row } from "@faire/web--source/slate/Layout/Row";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { NoTranslate } from "@faire/web--source/ui/lib/localization/common";
import { Link } from "@faire/web--source/ui/LinkAnchor";
import { trackSeoSuppliersPageBrandListBrandTileClick } from "@faire/web-api--source/events/seo/click/suppliersPageBrandListBrandTile";
import { ISearchBrandsV2Response } from "@faire/web-api--source/indigofair/data/ISearchBrandsV2Response";
import brandUrl from "@faire/web-api--source/routes/www/brand/brandToken";

export const BrandTile: React.FC<{
  brand: ISearchBrandsV2Response.IBrand;
  categoryPathIdentifier: string;
}> = ({ brand, categoryPathIdentifier }) => {
  const { strictLocalize } = useStrictLocalization();
  const { formatMoney } = useFormatMoney();
  const { token, image, name, minimum_order_amount, brand_reviews_summary } =
    brand;

  if (!token || !image || !name) {
    return null;
  }
  const minimum = minimum_order_amount
    ? strictLocalize(
        {
          defaultMessage: "{minMoney} min",
          description: {
            text: "minMoney is the minimum a retailer must order to be able to order from this brand",
            img: "https://cdn.faire.com/fastly/0af15a1293140e113bc4363332ecb9ddbaab16b574a671ac59672c1d94da7330.png",
          },
        },
        {
          minMoney: formatMoney({
            money: minimum_order_amount,
            omitCentsIfZero: true,
          }),
        }
      )
    : null;
  return (
    <Link
      className="px-2"
      to={brandUrl(token)}
      onClick={() =>
        trackSeoSuppliersPageBrandListBrandTileClick(
          token,
          categoryPathIdentifier
        )
      }
    >
      <Column>
        <TileImage image={image} imageAltText={name} />
        <Spacer size="1x" />
        <Typography maxLines={2} variant="paragraphSansMedium">
          <NoTranslate>{name}</NoTranslate>
        </Typography>
        <Spacer size="1/2x" />
        <Row align="center">
          {brand_reviews_summary ? (
            <BrandRating brandReviewSummary={brand_reviews_summary} />
          ) : null}
          {brand_reviews_summary && minimum ? (
            <>
              <Spacer width={4} />
              {" · "}
              <Spacer width={4} />
            </>
          ) : null}
          {minimum ? <Typography>{minimum}</Typography> : null}
        </Row>
        <Spacer height="3x" />
      </Column>
    </Link>
  );
};
